import { createTheme } from '@mui/material/styles';

const appTheme = createTheme({
  palette: {
    primary: {
      main: '#003087'
    },
    background: {
      // default: '#EDF3FC'
    }
  },
  typography: {
    h5: {
      fontFamily: "'Museo Sans', sans-serif",
      fontWeight: 500,
      fontSize: 24,
      color: '#003087'
    },
    fontSize: 12,
    button: {
      textTransform: 'none'
    }
  },
  components: {
    // Name of the component
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          fontSize: '18px'
        }
      }
    },
    Icon: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          fontSize: '18px'
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          fontSize: '28px'
        }
      }
    }
  }
});

export default appTheme;
